import * as angular from "angular";
import {DocumentSettings} from "../models/document-settings.model";
import {ReminderSettings} from "../models/reminder-settings.model";
import {AbsenceReasonSettings} from "../models/absence-reason-settings.model";
import {BreakType} from "../models/break-type.model";
import {VehicleStatusChangeReasonSettingsEntity} from "../models/vehicle-status-change-reason-settings.model";

export class SettingsRequestsService {

  /* @ngInject */
  constructor(private SettingsAPI, private $settings) {
  }

  getSiteMetadata() {
    const api = this.SettingsAPI.actions.getSiteMetadata;
    return this.$$call(api, {}, {}, {});
  }

  createMetadata(data) {
    const api = this.SettingsAPI.actions.createMetadata;
    return this.$$call(api, {}, data, {});
  }

  updateMetadata(id, data) {
    const api = this.SettingsAPI.actions.updateMetadata;
    return this.$$call(api, {}, data, {id: id});
  }

  deleteMetadata(id) {
    const api = this.SettingsAPI.actions.deleteMetadata;
    return this.$$call(api, {}, {}, {id: id});
  }

  getDocuments() {
    const api = this.SettingsAPI.actions.getDocuments;
    return this.$$call(api, {}, {}, {});
  }


  createDocument(document: Document) {
    const api = this.SettingsAPI.actions.createDocument;
    return this.$$call(api, {}, document, {});
  }

  updateDocument(document: DocumentSettings) {
    const api = this.SettingsAPI.actions.updateDocument;
    return this.$$call(api, {}, document, {id: document.id});
  }

  deleteDocument(document: DocumentSettings) {
    const api = this.SettingsAPI.actions.deleteDocument;
    return this.$$call(api, {}, {}, {id: document.id});
  }

  getReminders() {
    const api = this.SettingsAPI.actions.getReminders;
    return this.$$call(api, {}, {}, {});
  }

  createReminder(reminder: ReminderSettings) {
    const api = this.SettingsAPI.actions.createReminder;
    return this.$$call(api, {}, reminder, {});
  }

  updateReminder(reminder: ReminderSettings) {
    const api = this.SettingsAPI.actions.updateReminder;
    return this.$$call(api, {}, reminder, {id: reminder.id});
  }

  deleteReminder(reminder: ReminderSettings) {
    const api = this.SettingsAPI.actions.deleteReminder;
    return this.$$call(api, {}, {}, {id: reminder.id});
  }

  getAllVehicleStatusChangeReason() {
    const api = this.SettingsAPI.actions.getAllVehicleStatusChangeReason;
    return this.$$call(api, {}, {}, {});
  }

  createVehicleStatusChangeReason(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) {
    const api = this.SettingsAPI.actions.createVehicleStatusChangeReason;
    return this.$$call(api, {}, vehicleStatusChangeReason, {});
  }

  updateVehicleStatusChangeReason(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) {
    const api = this.SettingsAPI.actions.updateVehicleStatusChangeReason;
    return this.$$call(api, {}, vehicleStatusChangeReason, {id: vehicleStatusChangeReason.id});
  }

  deleteVehicleStatusChangeReason(vehicleStatusChangeReason: VehicleStatusChangeReasonSettingsEntity) {
    const api = this.SettingsAPI.actions.deleteVehicleStatusChangeReason;
    return this.$$call(api, {}, {}, {id: vehicleStatusChangeReason.id});
  }

  getOneVehicleStatusChangeReason(id: string) {
    const api = this.SettingsAPI.actions.getOneVehicleStatusChangeReason;
    return this.$$call(api, {}, {}, {id: id});
  }


  getAbsenceReasons() {
    const api = this.SettingsAPI.actions.getAbsenceReasons;
    return this.$$call(api, {}, {}, {});
  }

  createAbsenceReason(absenceReason: AbsenceReasonSettings) {
    const api = this.SettingsAPI.actions.createAbsenceReason;
    return this.$$call(api, {}, absenceReason, {});
  }

  updateAbsenceReason(absenceReason: AbsenceReasonSettings) {
    const api = this.SettingsAPI.actions.updateAbsenceReason;
    return this.$$call(api, {}, absenceReason, {id: absenceReason.id});
  }

  deleteAbsenceReason(absenceReasonId: string) {
    const api = this.SettingsAPI.actions.deleteAbsenceReason;
    return this.$$call(api, {}, {}, {id: absenceReasonId});
  }

  createBreakType(breakType: BreakType) {
    const api = this.SettingsAPI.actions.createBreakType;
    return this.$$call(api, {}, breakType, {});
  }

  updateBreakType(breakType: BreakType) {
    const api = this.SettingsAPI.actions.updateBreakType;
    return this.$$call(api, {}, breakType, {id: breakType.id});
  }

  deleteBreakType(breakTypeId: string) {
    const api = this.SettingsAPI.actions.deleteBreakType;
    return this.$$call(api, {}, {}, {id: breakTypeId});
  }

  getShipperAppConfig() {
    const api = this.SettingsAPI.actions.shipperAppConfig;
    return this.$$call(api, {}, {}, {});
  }

  updateOrderShipperAppConfig(payload) {
    const api = this.SettingsAPI.actions.updateOrderShipperAppConfig;
    return this.$$call(api, {}, payload, {});
  }

  updateCustomerShipperAppConfig(payload) {
    const api = this.SettingsAPI.actions.updateCustomerShipperAppConfig;
    return this.$$call(api, {}, payload, {});
  }

  updatePaymentShipperAppConfig(payload) {
    const api = this.SettingsAPI.actions.updatePaymentShipperAppConfig;
    return this.$$call(api, {}, payload, {});
  }

  getEmailReportConfiguration() {
    const api = this.SettingsAPI.actions.emailReportConfiguration;
    return this.$$call(api, {}, {}, {});
  }

  createEmailReportConfiguration(emailReportTemplateCofiguration) {
    const api = this.SettingsAPI.actions.createEmailReportConfiguration;
    return this.$$call(api, {}, emailReportTemplateCofiguration, {});
  }

  updateEmailReportConfiguration(emailReportTemplateCofiguration, emailReportType) {
    const api = this.SettingsAPI.actions.updateEmailReportConfiguration;
    return this.$$call(api, {}, emailReportTemplateCofiguration, {emailReportType: emailReportType});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$settings().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('settingsRequestsService', SettingsRequestsService);
